import { AppStoreReducer } from './AppStore/AppReducer';
import { DataStore, StoreActions } from './reducer.types';
import { GenerationFormStoreReducer } from './GenerationFormStore';
import { UserStoryStoreReducer } from './UserStoryStore';

export const DataStoreReducer = (
  { appState, userStoryState, generationFormState }: DataStore,
  action: StoreActions
) => ({
  appState: AppStoreReducer(appState, action),
  userStoryState: UserStoryStoreReducer(userStoryState, action),
  generationFormState: GenerationFormStoreReducer(generationFormState, action)
});
